module.exports = __webpack_public_path__ + "static/media/plus-square.c176bf58.svg";